import { TagSmall } from '@wix/wix-ui-icons-common';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { classes, st } from './DiscountName.st.css';

type DiscountNameProps = {
  discountName: string | undefined;
  /** Shows a tag icon before the name and puts `discountNote` after it, as the checkout does. */
  showDiscountTag?: boolean;
  discountNote?: string;
};

export const DiscountName: FC<DiscountNameProps> = ({
  discountName,
  showDiscountTag,
  discountNote,
}) => {
  const { isMobile } = useEnvironment();

  if (!discountName) {
    return null;
  }

  return (
    <div
      data-hook="details-discount-name"
      className={st(classes.root, { isMobile, withTag: !!showDiscountTag })}
    >
      {showDiscountTag && (
        <TagSmall
          aria-hidden
          data-hook="details-discount-tag-icon"
          className={classes.tagIcon}
        />
      )}
      <Text className={classes.discountName}>{discountName}</Text>
      {discountNote && (
        <Text
          data-hook="details-discount-note"
          className={classes.discountNote}
          priority={TextPriority.secondary}
        >
          {showDiscountTag && (
            <span aria-hidden data-hook="details-discount-note-separator">
              ·{' '}
            </span>
          )}
          {discountNote}
        </Text>
      )}
    </div>
  );
};
